import React from 'react';
import { Printer } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function PrintOrder() {
  return <div className="min-h-screen bg-white p-8 max-w-4xl mx-auto" data-id="element-1393">
      <div className="mb-8 print:hidden" data-id="element-1394">
        <Button onClick={() => window.print()} className="gap-2" data-id="element-1395">
          <Printer className="h-4 w-4" data-id="element-1396" />
          Print Order
        </Button>
      </div>

      <div className="border border-slate-200 p-8 space-y-8" data-id="element-1397">
        {/* Header */}
        <div className="flex justify-between items-start" data-id="element-1398">
          <div data-id="element-1399">
            <h1 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-1400">
              Desert Sage Seminars
            </h1>
            <div className="text-sm text-slate-600 space-y-1" data-id="element-1401">
              <p data-id="element-1402">123 Education Lane</p>
              <p data-id="element-1403">Phoenix, AZ 85001</p>
              <p data-id="element-1404">CALL US: (555) 123-4567</p>
              <p data-id="element-1405">Fax: (555) 987-6543</p>
              <p data-id="element-1406">E-Mail: info@desertsageseminars.com</p>
            </div>
          </div>
          <div className="text-right text-sm space-y-1" data-id="element-1407">
            <p data-id="element-1408">
              <span className="font-semibold" data-id="element-1409">Date:</span> 2023-10-15
            </p>
            <p data-id="element-1410">
              <span className="font-semibold" data-id="element-1411">Order id:</span> ORD-2023-001
            </p>
            <p data-id="element-1412">
              <span className="font-semibold" data-id="element-1413">Order status:</span> Processed
            </p>
          </div>
        </div>

        <hr className="border-slate-200" data-id="element-1414" />

        {/* Customer Info */}
        <div className="grid grid-cols-2 gap-8" data-id="element-1415">
          <div data-id="element-1416">
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-1417">Customer Info</h3>
            <div className="text-sm text-slate-600 space-y-1" data-id="element-1418">
              <p data-id="element-1419">
                <span className="font-semibold" data-id="element-1420">Company:</span> Acme Landscaping
              </p>
              <p data-id="element-1421">
                <span className="font-semibold" data-id="element-1422">First Name:</span> John
              </p>
              <p data-id="element-1423">
                <span className="font-semibold" data-id="element-1424">Last Name:</span> Doe
              </p>
              <p data-id="element-1425">
                <span className="font-semibold" data-id="element-1426">Phone:</span> 555-0123
              </p>
              <p data-id="element-1427">
                <span className="font-semibold" data-id="element-1428">Fax:</span> -
              </p>
              <p data-id="element-1429">
                <span className="font-semibold" data-id="element-1430">E-Mail:</span> john@example.com
              </p>
              <p data-id="element-1431">
                <span className="font-semibold" data-id="element-1432">URL:</span> -
              </p>
            </div>
          </div>
          <div data-id="element-1433">
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-1434">Billing Address</h3>
            <div className="text-sm text-slate-600 space-y-1" data-id="element-1435">
              <p data-id="element-1436">
                <span className="font-semibold" data-id="element-1437">Address:</span> 123 Desert Way
              </p>
              <p data-id="element-1438">
                <span className="font-semibold" data-id="element-1439">City:</span> Phoenix
              </p>
              <p data-id="element-1440">
                <span className="font-semibold" data-id="element-1441">State:</span> AZ
              </p>
              <p data-id="element-1442">
                <span className="font-semibold" data-id="element-1443">Zip:</span> 85001
              </p>
            </div>
          </div>
        </div>

        {/* Products Table */}
        <table className="w-full text-sm text-left border-collapse" data-id="element-1444">
          <thead data-id="element-1445">
            <tr className="bg-slate-50 border-y border-slate-200" data-id="element-1446">
              <th className="py-2 px-4 font-semibold text-slate-900" data-id="element-1447">SKU</th>
              <th className="py-2 px-4 font-semibold text-slate-900" data-id="element-1448">
                Product
              </th>
              <th className="py-2 px-4 font-semibold text-slate-900 text-right" data-id="element-1449">
                Item price
              </th>
              <th className="py-2 px-4 font-semibold text-slate-900 text-center" data-id="element-1450">
                Quantity
              </th>
              <th className="py-2 px-4 font-semibold text-slate-900 text-right" data-id="element-1451">
                Total
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200" data-id="element-1452">
            <tr data-id="element-1453">
              <td className="py-3 px-4" data-id="element-1454">C-101</td>
              <td className="py-3 px-4" data-id="element-1455">Desert Ecology Basics</td>
              <td className="py-3 px-4 text-right" data-id="element-1456">$49.00</td>
              <td className="py-3 px-4 text-center" data-id="element-1457">1</td>
              <td className="py-3 px-4 text-right" data-id="element-1458">$49.00</td>
            </tr>
          </tbody>
        </table>

        {/* Totals */}
        <div className="flex justify-end" data-id="element-1459">
          <div className="w-64 space-y-2 text-sm" data-id="element-1460">
            <div className="flex justify-between" data-id="element-1461">
              <span className="text-slate-600" data-id="element-1462">Subtotal:</span>
              <span className="font-medium" data-id="element-1463">$49.00</span>
            </div>
            <div className="flex justify-between" data-id="element-1464">
              <span className="text-slate-600" data-id="element-1465">Coupon saving (SUMMER23):</span>
              <span className="font-medium text-green-600" data-id="element-1466">-$10.00</span>
            </div>
            <div className="flex justify-between border-t border-slate-200 pt-2" data-id="element-1467">
              <span className="text-slate-600" data-id="element-1468">Discounted subtotal:</span>
              <span className="font-medium" data-id="element-1469">$39.00</span>
            </div>
            <div className="flex justify-between border-t border-slate-900 pt-2 text-base font-bold" data-id="element-1470">
              <span data-id="element-1471">Total:</span>
              <span data-id="element-1472">$39.00</span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-slate-200 text-center" data-id="element-1473">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-50 rounded border border-slate-200" data-id="element-1474">
            <span className="font-bold text-slate-700" data-id="element-1475">Authorize.Net</span>
            <span className="text-xs text-slate-500" data-id="element-1476">
              Secure Payment Processing
            </span>
          </div>
        </div>
      </div>
    </div>;
}